import React, { useContext, useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

// Styles
import "./ShoppingCart.scss"

// Component
import { StateContext, ShoppingProvider } from "../../StateProvider"
import Bubble from "./Bubble/Bubble"

const ShoppingCart = () => {
  const [state] = useContext(StateContext)
  const [showCart, setShowCard] = useState(false)

  const navImg = useStaticQuery(graphql`
    query {
      shoppingCart: file(relativePath: { eq: "shopping_cart.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  const choosenAttractions = state && state.filter(item => item.state)

  const openCart = () => {
    setShowCard(!showCart)
  }

  return (
    <>
      <div className="shopping-cart-container" onClick={openCart}>
        {choosenAttractions && choosenAttractions.length > 0 && (
          <div className="cart-state">{choosenAttractions.length}</div>
        )}
        <Img fluid={navImg.shoppingCart.childImageSharp.fluid} />
      </div>
      <ShoppingProvider>
        {showCart && (
          <Bubble articleArr={choosenAttractions} openCart={openCart} />
        )}
      </ShoppingProvider>
    </>
  )
}

export default ShoppingCart
